"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationContainer = exports.StyledPageTrackerContainer = exports.StyledPageSelectContainer = exports.StyledPageInput = exports.StyledPageButtonRightIcon = exports.StyledPageButtonLeftIcon = exports.StyledPageButton = exports.StyledGoToPageContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _MdKeyboardArrowLeft = require("@react-icons/all-files/md/MdKeyboardArrowLeft");

var _MdKeyboardArrowRight = require("@react-icons/all-files/md/MdKeyboardArrowRight");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Button = _interopRequireDefault(require("../Button/Button.index"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput.index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var StyledPaginationContainer = _styledComponents["default"].div.withConfig({
  displayName: "Paginationstyles__StyledPaginationContainer",
  componentId: "sc-ocyu9l-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w-100 tr"]))));

exports.StyledPaginationContainer = StyledPaginationContainer;

var StyledPageSelectContainer = _styledComponents["default"].div.withConfig({
  displayName: "Paginationstyles__StyledPageSelectContainer",
  componentId: "sc-ocyu9l-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["dib nowrap mh1 va-center"]))));

exports.StyledPageSelectContainer = StyledPageSelectContainer;

var StyledGoToPageContainer = _styledComponents["default"].div.withConfig({
  displayName: "Paginationstyles__StyledGoToPageContainer",
  componentId: "sc-ocyu9l-2"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["dib mh1 v-top"]))));

exports.StyledGoToPageContainer = StyledGoToPageContainer;

var StyledPageTrackerContainer = _styledComponents["default"].div.withConfig({
  displayName: "Paginationstyles__StyledPageTrackerContainer",
  componentId: "sc-ocyu9l-3"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["dib b fl mh1 v-top"]))));

exports.StyledPageTrackerContainer = StyledPageTrackerContainer;
var StyledPageButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Paginationstyles__StyledPageButton",
  componentId: "sc-ocyu9l-4"
})(["", " border-width:1px;", " height:2.125rem;", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["dib black b--black fl\n    ", "\n    ", "\n  "])), function (props) {
  return props.disabled && !(props.prepend || props.append) && 'bg-near-white';
}, function (props) {
  return (props.prepend || props.append) && (props.disabled ? 'gray' : 'orange');
}), function (props) {
  return props.wide ? 'width: 6rem;' : 'width: 2.15rem;';
}, function (props) {
  return props.selected && 'background: var(--light-orange);';
});
exports.StyledPageButton = StyledPageButton;
var StyledPageButtonLeftIcon = (0, _styledComponents["default"])(_MdKeyboardArrowLeft.MdKeyboardArrowLeft).withConfig({
  displayName: "Paginationstyles__StyledPageButtonLeftIcon",
  componentId: "sc-ocyu9l-5"
})(["margin-top:-0.2rem;height:1.5rem;width:1.5rem;"]);
exports.StyledPageButtonLeftIcon = StyledPageButtonLeftIcon;
var StyledPageButtonRightIcon = (0, _styledComponents["default"])(_MdKeyboardArrowRight.MdKeyboardArrowRight).withConfig({
  displayName: "Paginationstyles__StyledPageButtonRightIcon",
  componentId: "sc-ocyu9l-6"
})(["margin-top:-0.2rem;height:1.5rem;width:1.5rem;"]);
exports.StyledPageButtonRightIcon = StyledPageButtonRightIcon;
var StyledPageInput = (0, _styledComponents["default"])(_TextInput["default"]).withConfig({
  displayName: "Paginationstyles__StyledPageInput",
  componentId: "sc-ocyu9l-7"
})(["", " width:4.25rem;height:2.125rem;> label{", "}"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["dib mh3"]))), (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["gray fw4"]))));
exports.StyledPageInput = StyledPageInput;